<template>
    <div class="card bs-5 mb-5">
        <div class="fl-te-c pb-3">
            <h4 v-html="'CAREER REQUESTS'"></h4>
        </div>
        <vue-table :fields="fields" :url="listUrl" :per-page="10" ref="table">
            <template #resume="{rowData}">
                <btn title="Resume/CV" @click="viewResume(rowData.resume)" size="sm"/>
            </template>
        </vue-table>
    </div>
</template>

<script>
import urls from '../../../data/urls';

export default {
    name : 'CareerApplicants',
    data () {
        return {
            listUrl : urls.admin.career.applicantList,
            fields  : [
                {
                    name      : 'career',
                    sortField : 'career',
                    title     : 'Career'
                },
                {
                    name      : 'name',
                    sortField : 'name',
                    title     : 'Name'
                },
                {
                    name      : 'email',
                    sortField : 'email',
                    title     : 'E-Mail'
                },
                {
                    name      : 'contact_number',
                    sortField : 'contact_number',
                    title     : 'Phone'
                },
                {
                    name      : 'add_info',
                    sortField : 'add_info',
                    title     : 'Additional Info'
                },
                {
                    name       : '__slot:resume',
                    title      : 'Resume/CV',
                    titleClass : 'center aligned text-right',
                    dataClass  : 'aligned text-right'
                }
            ]
        };
    },
    methods : {
        viewResume (url) {
            window.open(url);
        }
    }
};
</script>

<style scoped>

</style>
